<template lang="pug">
include ../../utils/picture.pug
include ../../utils/icon-btn.pug
transition(name="fade")
  .modal(v-if="showModal")
      button.modal__overlay.js-modal-close(@click="closeModal")
      .modal__content.trs
          .modal__close-btn(@click="closeModal")
             +icon-btn(` js-modal-close`, {
                                        text: `Закрыть модальное окно`,
                                        icons: [
                                          {
                                            picture: {
                                              svgName: `i-close`,
                                              isSVG: true,
                                              basePathParam: '/local/templates/renaissance/layout/dist/'
                                              }
                                            }
                                          ]
                                      }
                                    )
          .modal__inner.bg-white
              .modal__wrapper
                  h2.modal__title.t-h2.clr-blue-7(v-if="productTitle") Запрос стоимости: {{productTitle}}
                  h2.modal__title.t-h2.clr-blue-7(v-if="!productTitle") {{title}}
                  form(
                    @submit.prevent="formSubmit" name=some
                    v-if="!isSuccess"
                  ).js-form.modal__form
                    component(
                        v-for="item in fields"
                        v-bind:is="getComponentByType(item.component)"
                        v-model="updateField"
                        :key="item.id"
                        :item="item"
                    )
                    button.modal__submit.btn.btn--outline.btn-submit.clr-blue-10(
                        type=`submit`
                        data-text submit
                        data-success= success
                        v-bind:class="{ active: isSuccess }"
                    ) {{sendText}}
                    .input.field.modal__input--privacy-check
                      input.input__el.clr-blue-22.trs(type="checkbox" checked="true")
                      label.input__label Отправляя заявку, я подтверждаю, что ознакомлен и согласен с Политикой конфиденциальности данного сайта

                    .form-error(v-if="errors.length") {{error}}
                  .success-message(v-if="isSuccess") Отправлено!
</template>

<script>
  import Vue from 'vue'
  import store from '~/js/store'
  import textField from '~/pug/blocks/field/field.vue'
  import fileField from '~/pug/blocks/field/file.vue'
  import textareaField from '~/pug/blocks/field/textarea.vue'
  import checkboxField from '~/pug/blocks/field/checkbox.vue'
  import sendform from './sendform.js'
  import validate from './validate.js'

  const basemodal = {
    data() {
      return {
        errors: [],
        isSuccess: false,
        isValid: false,
      }
    },
    components: {
      textField, fileField, textareaField, checkboxField
    },
    computed: {
      showModal () {
        this.isSuccess = false
        return store.state.modal.show
      },
      title () {
        return store.state.modal.title
      },
      productTitle() {
        if (store.state.productInfo) {
          return  store.state.productInfo.NAME
        }
      },
      sendText () {
        return store.state.modal.submitText
      },
      fields () {
        let fields

        fields = store.state.modal.fields.map(function(field) {
          return field
        })

        return fields
      },
      updateField: {
        get: function(test) {
        },
        set: function(newField) {
          store.commit('changeField', newField);
        }
      }
    },
    methods: {
        closeModal() {
            store.commit('modalHide');
        },
        formSubmit(e) {
          let result
          let fields
          let isValid

          isValid = true;

          fields = store.state.modal.fields.map(function(field) {
            field = validate(field)
            if (field.error === true) {
              isValid = false
            }
            return field
          })

          store.commit('validateFields', fields);

          if (isValid === true) {
            result = sendform(store.state.modal)
            result.then(response => {
              if (response.data.success === true) {
                this.isSuccess = true
              }
            })
          }
        },
        getComponentByType(type) {
          return type + 'Field'
        }
    }
  }

  export default basemodal
</script>
